import { Box, Text } from "@chakra-ui/react";

export default function NoteContainer({ children }) {
  return (
    <Box borderRadius="16px" py="12px" px="9px" mt="16px" bg="primaryLight" w="100%">
      <Text fontSize="12px" fontWeight={400} lineHeight="20px" letterSpacing={0.15} color="mediumEmphasis">
        {children}
      </Text>
    </Box>
  );
}
